export default function TrafficLights({ onClose }) {
  return (
    <div className="flex items-center gap-2 pl-3" data-testid="window-traffic-lights">
      <button
        data-testid="window-close-btn"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        onPointerDown={(e) => e.stopPropagation()}
        className="group relative flex items-center justify-center w-7 h-7 -m-1 rounded-full"
        aria-label="Close window"
      >
        <span className="flex items-center justify-center w-3.5 h-3.5 rounded-full bg-[#ff5f57] border border-[#e0443e] group-hover:brightness-90 transition">
          <svg viewBox="0 0 8 8" className="w-2 h-2 opacity-0 group-hover:opacity-100 transition-opacity" stroke="#7a1f1a" strokeWidth="1.4" strokeLinecap="round">
            <path d="M1.5 1.5 L6.5 6.5 M6.5 1.5 L1.5 6.5" />
          </svg>
        </span>
      </button>
      <span className="w-3 h-3 rounded-full bg-[#febc2e] border border-[#d89e24]" />
      <span className="w-3 h-3 rounded-full bg-[#28c840] border border-[#1dad2b]" />
    </div>
  );
}
